export default "__VITE_ASSET__QUs4v_Sa__"